import { NotificationShopPreferencesApiClient } from '@fourthwall/services/dist/NotificationShopPreferencesApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useNotificationShopPreferencesQuery = createQueryHook(
  NotificationShopPreferencesApiClient.getNotificationShopPreferences,
  {
    queryKey: ['notificationShopPreferences'],
  },
)
